import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Sample from "../types/sample";
import http from "../api/http";

interface SampleState {
    sample?: Sample;
    status: "idle" | "loading" | "failed";
};

const initialState: SampleState = {
    sample: undefined,
    status: "idle",
};

export const getSample = createAsyncThunk<Sample>("sample/get", async () => {
    const response = await http.get<Sample>(`/sample`);
    return response.data;
});

const sampleSlice = createSlice({
    name: "sample",
    initialState,
    reducers: {
        exampleReducer(state, action){
            state.sample = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getSample.pending, (state) => {
            state.status = "loading"
        })
        .addCase(getSample.fulfilled, (state, action) => {
            state.status = "idle";
            state.sample = action.payload;
        })
        .addCase(getSample.rejected, (state) => {
            state.status = "failed";
        })
    }
});

export default sampleSlice.reducer
export const { exampleReducer } = sampleSlice.actions;
